export const APPEARANCES = {
  accent: 'accent',
  cta: 'cta',
  white: 'white',
  outline: 'outline',
  accentSecondary: 'accent-secondary',
  ctaSecondary: 'cta-secondary',
  successSecondary: 'success-secondary',
  dangerSecondary: 'danger-secondary',
};

export const SIZES = {
  large: 'large',
  medium: 'medium',
  semiSmall: 'semi-small',
  small: 'small',
};
